// skills/husbandry/index.js
// Husbandry skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderHusbandryUI,
    updateHusbandryUI,
    initHusbandryUI,
    switchTab,
    getCurrentTab,
    unlockPet,
    evolvePet,
    openPetModal,
    closePetModal,
    switchPetModalTab,
    assignContract,
    cancelContract,
    completeContract,
    claimItem,
    claimAll,
    openFeedModal,
    closeFeedModal,
    feedPet,
    setNotificationThreshold
} from './husbandryUI.js';

/**
 * Husbandry skill configuration
 * Passive pet management system - NO active action
 * Manages its own tabs internally for persistence (like Crafting)
 */
const husbandryConfig = {
    id: 'husbandry',
    name: 'Husbandry',
    icon: '🐾',
    iconImage: 'assets/icons/skill_icons/husbandry.png',
    description: 'Manage pets and send them on contracts for rewards',

    // Don't use router-level tabs - they interfere with persisted state
    // Tabs are managed internally in husbandryUI.js

    render(params = {}) {
        // If tab provided in URL, use it; otherwise use persisted tab
        const tab = params.tab || getCurrentTab();
        renderHusbandryUI({ ...params, tab });
    },

    update() {
        updateHusbandryUI();
    },

    init() {
        initHusbandryUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('husbandry', husbandryConfig);

if (typeof window !== 'undefined') {
    window.husbandryUI = {
        switchTab,
        unlockPet,
        evolvePet,
        openPetModal,
        closePetModal,
        switchPetModalTab,
        assignContract,
        cancelContract,
        completeContract,
        claimItem,
        claimAll,
        openFeedModal,
        closeFeedModal,
        feedPet,
        setNotificationThreshold
    };
}

export default husbandryConfig;
